/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M957.44 445.44H578.56V66.56C578.56 29.696 548.864 0 512 0s-66.56 29.696-66.56 66.56v378.88H66.56C29.696 445.44 0 475.136 0 512s29.696 66.56 66.56 66.56h378.88v378.88c0 36.864 29.696 66.56 66.56 66.56s66.56-29.696 66.56-66.56V578.56h378.88c36.864 0 66.56-29.696 66.56-66.56s-29.696-66.56-66.56-66.56z"/>'
  }
})
